
import './App.css';
import AdviceGenerator from './components/adviceGenerator/AdviceGenerator';

function App() {
  return (
    <div className="App">
      <AdviceGenerator />
    </div>
  );
}

export default App;
